import { useState } from "react";
import { chapters } from "@/mocks/comicData";

type FilterKey = "all" | "recent";

export default function LatestChapters() {
  const [filter, setFilter] = useState<FilterKey>("all");

  const list = filter === "all" ? chapters : chapters.filter((c) => c.isNew || c.status === "已更新").slice(0, 4);

  return (
    <section id="chapters" className="w-full py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
              <i className="ri-flashlight-line"></i>最新章节
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              最新章节列表 · 今天有没有更新一眼便知
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              汇总天才医仙漫画最新更新章节与连载进度，最近更新的内容已置顶展示，点击即可继续追更。
            </p>
          </div>

          <div className="inline-flex self-start rounded-full border border-background-200 bg-background-50 px-1 py-1 sm:self-auto">
            {(
              [
                { key: "all", label: "全部章节" },
                { key: "recent", label: "近期更新" },
              ] as { key: FilterKey; label: string }[]
            ).map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setFilter(t.key)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  filter === t.key
                    ? "bg-primary-600 text-background-50"
                    : "text-foreground-700 hover:text-primary-700"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid gap-3 md:grid-cols-2">
          {list.map((c) => (
            <article
              key={c.id}
              className={`flex items-center gap-4 rounded-lg border p-4 transition-colors ${
                c.isNew
                  ? "border-accent-300 bg-accent-50"
                  : "border-background-200 bg-background-100/60 hover:border-primary-300"
              }`}
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                  c.isNew ? "bg-accent-500 text-background-50" : "bg-primary-600 text-background-50"
                }`}
              >
                {c.no.replace("第", "").replace("话", "")}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="truncate font-medium text-foreground-950">
                  {c.no} · {c.title}
                </h3>
                <p className="mt-0.5 text-xs text-foreground-600">{c.time}</p>
              </div>
              {c.isNew && (
                <span className="flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 text-xs text-accent-700">
                  <i className="ri-sparkling-2-line"></i>今日更新
                </span>
              )}
              <a
                href="#follow"
                aria-label={`开始阅读${c.no}`}
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-background-50 text-foreground-700 shadow-none ring-1 ring-background-200 transition-colors hover:bg-primary-600 hover:text-background-50"
              >
                <i className="ri-arrow-right-line"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}